// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/forced-landing-checklist.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/forced-landing-checklist/forced-landing-checklist.js';

mount([g0]);
